import React from "react";
import StarRatings from "react-star-ratings";
import { BiLike } from "react-icons/bi";

function ReviewCard({ name, rating, comment, avatar, date }) {
  return (
    <div className="mb-3 border-bs p-2 shadow">
      <p>{name}</p>
      <div className="flex justify-between">
        <div className="flex text-[#FF7A00]">
          <StarRatings
            rating={rating}
            starRatedColor="#FFBF00"
            // changeRating={this.changeRating}
            numberOfStars={5}
            name="rating"
            starDimension="15px"
            starSpacing="1px"
          />
        </div>
        <p> {(date && date) || "July 24, 2022"}</p>
      </div>
      <p>{comment}</p>
      {/* <p className="text-sm text-slate-500">
        535 people found this review useful
      </p> */}
      {/* <div className="flex justify-between text-sm">
        <button className="text-slate-700 flex items-center">
          Helpfull <BiLike className="inline" />
        </button>
      </div> */}
    </div>
  );
}

export default ReviewCard;
